export default __webpack_public_path__ + "static/escritorioSp-cea039ff2c86883fbb3550bacae8b43e.jpg";